/**
 * Country → supported app language codes.
 * Only includes languages present in supportedLanguages / languageUtils.
 */
const COUNTRY_LANGUAGES_MAP: Record<string, string[]> = {
  IN: ['en', 'hi', 'te', 'ta', 'kn'],
  US: ['en'],
  GB: ['en'],
  CA: ['en'],
  AU: ['en'],
  SG: ['en'],
  AE: ['en'],
  SA: ['en'],
  BD: ['en', 'hi'],
  PK: ['en', 'hi'],
  OTHER: ['en'],
};

export default COUNTRY_LANGUAGES_MAP;
